
import { UploadFile } from "../types/type";

export const funCalculateTotalFileSize = ( uploadFiles: UploadFile[], files: FileList): number => {
        const currentTotalSize = uploadFiles.reduce((acc, f) => {
                let sizeInBytes = 0;
                if (f.size.includes("MB")) {
                        sizeInBytes = parseFloat(f.size) * 1024 * 1024;
                } else if (f.size.includes("Ko")) {
                        sizeInBytes = parseFloat(f.size) * 1024;
                }
                return acc + sizeInBytes;
        }, 0);

        const newFilesSize = Array.from(files).reduce((acc, file) => acc + file.size, 0);

        return currentTotalSize + newFilesSize
}